import { z } from "zod";
export const paginationQuerySchema = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
});
export function encodeCursor(payload) {
    return Buffer.from(JSON.stringify(payload), "utf8").toString("base64url");
}
export function decodeCursor(cursor) {
    try {
        const json = Buffer.from(cursor, "base64url").toString("utf8");
        const parsed = JSON.parse(json);
        if (typeof parsed === "object" &&
            parsed !== null &&
            typeof parsed.id === "string" &&
            typeof parsed.createdAt === "string") {
            return parsed;
        }
        return null;
    }
    catch {
        return null;
    }
}
export function paginatedResponseSchema(itemSchema) {
    return z.object({
        items: z.array(itemSchema),
        nextCursor: z.string().nullable(),
    });
}
/**
 * Offset pagination — the alternative to the cursor scheme above. Used only by
 * the browse-style list endpoints (`/contacts`, `/admin/users`) where the UI
 * needs a numbered page list and jump-to-page, which keyset pagination can't
 * express. `page` is 1-based. Trade-off: concurrent inserts/deletes can shift
 * rows across page boundaries (skip/repeat), acceptable for these views.
 */
export const offsetPaginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(50),
});
export function offsetPaginatedResponseSchema(itemSchema) {
    return z.object({
        items: z.array(itemSchema),
        total: z.number().int(),
        page: z.number().int(),
        pageSize: z.number().int(),
    });
}
//# sourceMappingURL=pagination.js.map